/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Novelist API
 * Admin REST API
 * OpenAPI spec version: 1b8b3abca32e2944b8fba3ab2fea012630968b0b
 */

/**
 * Product variant — controls entitlement requirement and publisher billing.
 */
export type ProductVariant = typeof ProductVariant[keyof typeof ProductVariant];


export const ProductVariant = {
  full: 'full',
  demo: 'demo',
  preview: 'preview',
} as const;
